<template>
    <vue-scroll :ops="$ops">
    <div class="layout">
        <div class="left">
            <div class="card calendar-box">
                <div class="card-header calendar">
                    <div style="line-height: 30px">
                        标准教案
                    </div>
                    <div>
                        <el-date-picker
                                v-model="date"
                                type="date"
                                format="yyyy 年 MM 月"
                                style="width: 140px"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <Calendar  v-model="date" :dates="['2019-02-12']" @change="handleChoose(0,'date')"></Calendar>
            </div>
            <div class="card filter-box">
                <div class="left-flex">
                    <vue-scroll :ops="ops">
                        <div>
                            <header class="choose">
                                <img src="@/assets/img/educationalAdministration/firstFilter.png"  class="img" />
                                <h3 class="content" style="color:#6a6a81;" @click="handleChoose('','grade')">年级</h3>
                            </header>
                            <ul >
                                <li :key="grade.id" v-for="grade in grades " @click="handleChoose(grade.id,'grade')" >
                                    <template v-if="grade.id===chosen.grade_id">
                                        <i class="el-icon-caret-right tag" ></i>
                                        <span class="active">{{grade.name}}</span>
                                    </template>
                                    <span class="cancel" v-else>{{grade.name}}</span>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <header class="choose" >
                                <img src="@/assets/img/educationalAdministration/secondFilter.png"  class="img" />
                                <h3 class="content" style="color:#b66930;top:8px" @click="handleChoose('','subject')">学科</h3>
                            </header>
                            <ul>
                                <li :key="subject.id" v-for="subject in subjects " @click="handleChoose(subject.id,'subject')" >
                                    <template v-if="subject.id===chosen.subject_id">
                                        <i class="el-icon-caret-right tag" ></i>
                                        <span class="active">{{subject.name}}</span>
                                    </template>
                                    <span class="cancel" v-else>{{subject.name}}</span>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <header class="choose" >
                                <img src="@/assets/img/educationalAdministration/thirdFilter.png"  class="img" />
                                <h3 class="content" style="color:#cdbe4e;top:10px" @click="handleChoose('','class_type')">班型</h3>
                            </header>
                            <ul >
                                <li :key="class_type.id" v-for="class_type in class_types " @click="handleChoose(class_type.id,'class_type')" >
                                    <template v-if="class_type.id===chosen.class_type_id">
                                        <i class="el-icon-caret-right tag" ></i>
                                        <span class="active">{{class_type.content}}</span>
                                    </template>
                                    <span class="cancel" v-else>{{class_type.content}}</span>
                                </li>
                            </ul>
                        </div>
                    </vue-scroll>
                </div>
                <div class="right-flex">
                    <vue-scroll :ops="ops" >
                        <ul>
                            <li :key="classx.id"
                                v-for="classx in classes "
                                @click="handleChooseClassPlan(classx.class_plan_id)"
                                @dblclick="handleInClassPlan(classx.class_plan_id)"
                                :class="{'active':chosen.classPlan_id.includes(classx.class_plan_id)}"
                                draggable="true"
                                @dragover='allowDrop($event)'
                                v-on:mousedown="handleMousedown(classx.class_plan_id)">
                                <i class="tag" :style="{'background-color': classx.lessonPlan_color}" v-if="classx.lessonPlan_color"></i>
                                <span >{{classx.class}}</span>
                            </li>
                        </ul>
                    </vue-scroll>
                </div>
            </div>
        </div>
        <div class="right card"  @drop='drop($event)'  @dragover='allowDrop($event)'>
            <div >
                <el-tabs type="border-card" style="height: 870px">
                    <el-tab-pane label="教案" class="tab-pane">
                        <TeacherPlan  ref="teacherPlan" v-on:changeState="changeState"></TeacherPlan>
                    </el-tab-pane>
                    <el-tab-pane label="作业" class="tab-pane">作业</el-tab-pane>
                    <el-tab-pane label="学生情况" class="tab-pane">学生情况</el-tab-pane>
                    <el-tab-pane label="回访" class="tab-pane">回访</el-tab-pane>
                </el-tabs>
                <div class="note">
                    <div style="float:left;margin:0 5px">
                        <div style="float:left;height: 22px;">标准教案：</div>
                        <div :key="item.id"  v-for="item in lessonStatus" style="float:left;margin:0 5px">
                            <div class="status-color"  :style="{'background': item.color}"></div>
                            <div style="float:left;height: 22px;">{{item.name}}</div>
                        </div>
                        <div style="float:left;height: 22px;margin:0 0px 5px 30px">上课教案：</div>
                        <div :key="item.id" v-for="item in teacherLessonStatus" style="float:left;margin:0 5px">
                            <div class="status-color" :style="{'background': item.color}"></div>
                            <div style="float:left;height: 22px;">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose">
            <div style="text-align: center;font-size: 26px;">是否打开该教案</div>
            <div style="text-align: center;margin-top: 30px">
                <el-button type="success" round @click="goToOtherClass()" style="width:160px;font-size: 20px">确 定</el-button>
            </div>
            <div style="text-align: center;margin-top: 10px">
                <el-checkbox v-model="saveBefore">是否丢弃来保存新内容</el-checkbox>
            </div>
        </el-dialog>
    </div>
    </vue-scroll>
</template>

<script>
    import Calendar from "./components/calendar/Index"
    import TeacherPlan from "./components/bookmarks/TeacherPlan"
    import store from '@/store'


    export default {
        name: "index",
        data() {
            return {
                chosen:{
                    grade_id:'',
                    subject_id:'',
                    class_type_id:'',
                    classPlan_id:[]
                },
                lessonStatus:[
                    {
                        name: '待审核',
                        color: '#eb7add'
                    },
                    {
                        name: '待修改',
                        color: '#4c6ed4'
                    },
                    {
                        name: '已通过',
                        color: '#50dec4'
                    }
                ],
                teacherLessonStatus:[
                    {
                        name: '待审核',
                        color: '#eb7a7a'
                    },
                    {
                        name: '已修改',
                        color: '#ebbf7a'
                    },
                    {
                        name: '已通过',
                        color: '#94d477'
                    }
                ],
                grades:[],
                subjects:[],
                class_types:[],
                classes:[],
                ops : {
                    rail: {
                        size:'0.5px',
                        gutterOfSide:'1px'
                    },
                    bar: {
                        background: '#d3d2d3'
                    },
                    scrollPanel: {
                        scrollingX: false,
                    }
                },
                date:this.$moment().format('YYYY-MM-DD'),
                activeName: 'first',
                choose_id:'',
                chooseClass:true,
                dialogVisible:false,
                saveBefore:false,
            };
        },
        components: {
            Calendar:Calendar,
            TeacherPlan:TeacherPlan
        },
        created() {
            this.handleChosenMsg();
            this.handleClass();
        },
        methods: {
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            handleChoose(type_id,type) {
                if(type==='grade'){
                    this.chosen.grade_id=type_id;
                }else if(type==='subject'){
                    this.chosen.subject_id=type_id;
                }else if(type==='class_type'){
                    this.chosen.class_type_id=type_id;
                }
                this.chosen.classPlan_id=[];
                this.handleClass();
            },
            handleClass(){
                this.$axios.get(store.state.server + '/educationalAdministration?grade_id='+this.chosen.grade_id
                    +'&subject_id='+this.chosen.subject_id
                    +'&class_type_id='+this.chosen.class_type_id
                    +'&date='+this.date
                    +'&'+localStorage.baseUrl).then((response) => {
                    if (response.data.status == 'success') {
                        this.classes=response.data.data.classes;
                    }
                })
            },
            handleChooseClassPlan(classPlan_id){
                if(this.chosen.classPlan_id.includes(classPlan_id)){
                    for (let i in this.chosen.classPlan_id) {
                        if(this.chosen.classPlan_id[i]===classPlan_id){
                            this.chosen.classPlan_id.splice(i,1);
                        }
                    }
                }else{
                    this.chosen.classPlan_id.push(classPlan_id);
                }

            },
            handleInClassPlan(){
            },
            handleChosenMsg(){
                this.$axios.get(store.state.server + '/educationalAdministration/create?'+localStorage.baseUrl).then((response) => {
                    if (response.data.status == 'success') {
                        this.grades= response.data.data.grades;
                        this.subjects= response.data.data.subjects;
                        this.class_types= response.data.data.classTypes;
                    }
                })
            },
            handleMousedown(classPlan_id){
                this.changeState(true);
                this.choose_id=classPlan_id;
            },
            changeState(val){
                this.chooseClass=val;
            },
            drop: function (evt) {
                if(this.chooseClass){
                    evt.preventDefault();
                    if(this.$refs.teacherPlan.classPlan_id!==''){
                        this.dialogVisible=true;
                    }else{
                        this.goToOtherClass();
                    }
                }
            },
            goToOtherClass(){
                if(!this.saveBefore && this.$refs.teacherPlan.classPlan_id!==''){
                    this.$refs.teacherPlan.handleSingleUpdate();
                    this.$refs.teacherPlan.handleSingleTeacherUpdate();
                }
                if(!this.chosen.classPlan_id.includes(this.choose_id)){
                    this.chosen.classPlan_id.push(this.choose_id);
                }
                this.$refs.teacherPlan.classPlan_id=this.choose_id;
                if(this.$refs.teacherPlan.lessonPlan){
                    this.$Echo.leave('lessonPlan.' + this.$refs.teacherPlan.lessonPlan.id);
                }
                this.$refs.teacherPlan.handleLogicalFrame();
                this.dialogVisible=false;
            },
            allowDrop: function (event) {
                event.preventDefault();
                return true;
            },
        }
    }
</script>

<style scoped lang="scss">
    .card {
        margin-bottom:10px;
    }
    .layout{
        .left {
            float: left;
            width: 365px;
        }

        .right {
            margin-left: 375px
        }
    }

    @media (min-width:1450px ){
        .note{
            position: absolute;
            top: 10px;
            right:30px;
            color:#666697;
            font-size:16px;
            .status-color{
                float:left;
                width: 3px;
                margin:0 8px;
                height:22px
            }
        }
    }
    @media (max-width: 1449px){
        .note{
            position: absolute;
            top: 10px;
            right:30px;
            color:#666697;
            font-size:10px;
            .status-color{
                float:left;
                width: 3px;
                margin:0 8px;
                height:12px
            }
        }
    }



    .filter-box {
        height: 700px;
        background-color:#F5F5F5;
        flex-direction:row;
        padding: 5px;
        .left-flex {
            width: 75px;
            height: 100%;
            display: flex;
            flex-direction:column;
            ul{
                margin: 0;
                list-style-type: none;
                padding: 0;
                li{
                    position: relative;
                    list-style-type: none;
                    font-size:17px;
                    line-height: 25px;
                    text-align: center;
                    font-weight: 100;
                    color:#6a6a81;
                    .cancel{
                        opacity:0.4;
                        &:hover{
                            opacity:0.8;
                        }
                    }
                    .active{
                        opacity:1;
                    }

                    .tag{
                        position: absolute;
                        left:2px;
                        top:3px;
                    }
                }
            }
        }
        .right-flex {
            background-color: #ffffff;
            height: 100%;
            width: 290px;
            display: flex;
            flex-direction:row;
            justify-content: flex-end;
            ul{
                margin: 0;
                list-style-type: none;
                width: 240px;
                li{
                    position: relative;
                    list-style-type: none;
                    font-size:20px;
                    line-height: 30px;
                    text-align: center;
                    font-weight: 100;
                    color:#cdcdda;
                    margin-bottom: 10px;
                    border:1px solid #cdcdda;
                    border-radius:5px;
                    .tag{
                        position: absolute;
                        width: 10px;
                        height: 22px;
                        background: #eb7a7a;
                        left:-15px;
                        top:3px;
                    }
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
                .active{
                    color:#6a6a81;
                    background: #cdcdda;
                }
            }
        }
    }
    .calendar-box{
        height: 150px;
        .calendar{
            display: flex;
            flex-direction:row;
            justify-content:space-between
        }
    }

    .choose{
        position:relative;
        .img{
            width:77px;
            height:45px
        }
        .content{
            position: absolute;
            top: 5px;
            left:20px;
            font-size: 18px;
        }
    }

    .hint{
        float: right;
        width:100px
    }

    .tab-pane{
        height: 850px;
    }



</style>
